import Vue from "vue";

export async function indexUsedCoverages(lead_number) {
  const response = await Vue.prototype.$http.get(
    `/leads/${lead_number}/used_coverages`
  );

  return response.data;
}

export async function updateFranchise(id, payload) {
  const response = await Vue.prototype.$http.put(
    `/policy_coverage/${id}/franchise`,
    payload
  );

  return response.data;
}

export function calcTotalToSpend(coverage) {
  return (
    Number(coverage.capital || 0) + Number(coverage.franchise_internal || 0)
  );
}
